import { render, staticRenderFns } from "./my-company.vue?vue&type=template&id=10c2c0b9&scoped=true"
import script from "./my-company.vue?vue&type=script&lang=js"
export * from "./my-company.vue?vue&type=script&lang=js"
import style0 from "./my-company.vue?vue&type=style&index=0&id=10c2c0b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2c0b9",
  null
  
)

export default component.exports